// ====================================
// RiskAssessment.jsx
// ====================================
import React from 'react';
import Button from '@/components/ui/Button';
import Icon from '@/components/AppIcon';

const RiskAssessment = ({ currentProfile, targetRole, riskData, onClose }) => {
const getRiskColor = (level) => {
switch (level) {
case 'low': return 'text-success';
case 'medium': return 'text-warning';
case 'high': return 'text-destructive';
default: return 'text-text-secondary';
}
};

return (
<div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
<div className="bg-card border border-border rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
<div className="p-6">
<div className="flex items-center justify-between mb-6">
<h2 className="text-2xl font-bold text-text-primary">Risk Assessment</h2>
<button onClick={onClose} className="text-text-secondary hover:text-text-primary">
<Icon name="X" size={24} />
</button>
</div>

<div className="space-y-6">
{riskData && Object.entries(riskData).map(([category, data]) => (
<div key={category} className="border border-border rounded-lg p-4">
<div className="flex items-center justify-between mb-2">
<h3 className="text-lg font-semibold text-text-primary capitalize">
{category.replace('_', ' ')}
</h3>
<span className={`text-sm font-medium ${getRiskColor(data.level)}`}>
{data.level?.toUpperCase()}
</span>
</div>
<p className="text-sm text-text-secondary">{data.description}</p>
</div>
))}
</div>

<div className="mt-6 flex justify-end">
<Button onClick={onClose}>Close</Button>
</div>
</div>
</div>
</div>
);
};

export default RiskAssessment;